<div *ngIf="providerOffice" class="provider-office">
  <app-office [office]="providerOffice.office" />
  <div *ngIf="providerOffice.status">({{ providerOffice.status | providerOfficeFaxStatus }})</div>
</div>
